export default __webpack_public_path__ + "static/media/logo-vw-comerciales.cb9898da.svg";